import React from 'react';

import { SiteConfigManager } from '@atlas/core';
import { Label } from '@atlas/ui';

const FooterPayment = () => {
  const methods = SiteConfigManager.getConfig('config.config.payment.method_list', []);
  const filteredMethods = methods?.filter(method => method.visible);

  const canRenderList = filteredMethods.length !== 0;

  return (
    <div className="payments">
      <Label className="block-title" message="footer_title_payment_methods" />
      {canRenderList && (
        <ul className="payments__list">
          {filteredMethods?.map(({icon, type}) => (
            <li className="payments__list__item" key={type}>
              <div className="payments__item__wrapper">
                <img className="payments__item__img" src={icon} alt={type} />
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FooterPayment;
